import FormDescription from './FormDescription'

export { FormDescription }

export default { FormDescription }
